import { useParams, Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SchemaOrg from '@/components/base/SchemaOrg';
import { featuredArticles } from '@/mocks/home';

export default function Article() {
  const { id } = useParams<{ id: string }>();
  const article = featuredArticles.find((a) => a.id === id);

  if (!article) {
    return (
      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main className="pt-16 flex items-center justify-center min-h-[60vh]">
          <div className="text-center">
            <div className="w-16 h-16 mx-auto mb-4 rounded-full bg-background-100 flex items-center justify-center">
              <i className="ri-error-warning-line text-2xl text-foreground-400"></i>
            </div>
            <h1 className="font-heading text-xl text-foreground-950 mb-2">文章未找到</h1>
            <p className="text-foreground-500 text-sm mb-6">该文章可能已被删除或不存在</p>
            <Link
              to="/"
              className="inline-flex items-center gap-2 px-5 py-2.5 bg-primary-500 text-white text-sm font-medium rounded-full hover:bg-primary-600 transition-colors duration-200 cursor-pointer"
            >
              <i className="ri-arrow-left-line"></i>
              返回首页
            </Link>
          </div>
        </main>
        <Footer />
      </div>
    );
  }

  const articleFullContent = {
    a1: `## 2026年亚洲电商市场趋势分析

随着亚洲各国数字经济快速发展，跨境电商市场呈现爆发式增长。2026年，亚洲电商市场规模预计将突破5万亿美元，占全球电商市场的65%以上。

### 一、市场增长驱动力

亚洲电商市场的快速增长主要得益于以下几个关键因素：

**移动支付普及率持续攀升**。从中国的支付宝、微信支付，到东南亚的GrabPay、GoPay，移动支付已成为亚洲消费者的首选支付方式。据统计，亚洲移动支付渗透率已达78%，远超全球平均水平。

**物流基础设施不断完善**。亚洲各国在物流领域的投资持续增加，智能仓储、自动化配送、跨境物流网络的建设大大缩短了配送时间，提升了消费者体验。

**社交电商异军突起**。以直播带货、社交分享为代表的新型电商模式在亚洲市场蓬勃发展。2026年，社交电商交易额预计占亚洲电商总额的30%以上。

### 二、重点市场分析

**中国市场**：作为亚洲最大的电商市场，中国继续保持强劲增长。跨境电商、农村电商、银发经济成为新的增长点。

**东南亚市场**：印度尼西亚、泰国、越南等国家电商增速领跑亚洲，年轻人口结构和快速增长的互联网普及率为电商发展提供了坚实基础。

**印度市场**：凭借庞大的人口基数和快速推进的数字化进程，印度电商市场正在经历爆发式增长，成为全球电商巨头竞相布局的重要市场。

### 三、趋势与展望

展望未来，亚洲电商市场将呈现以下趋势：AI技术深度赋能电商全链路、绿色可持续消费理念深入人心、跨境电商业态更加多元化、线上线下融合加速。这些趋势将为亚洲电商市场带来新的发展机遇。

亚洲在线将持续关注亚洲电商市场的最新动态，为您带来及时、深度的市场分析与报道。`,
    a2: `## 东京奥运会场馆变身：探访日本最新文旅融合项目

东京多个奥运场馆经过改造后重新向公众开放，融合文化、旅游、商业等多元功能，成为亚洲文旅融合的新标杆。

### 一、新国立竞技场的华丽转身

作为2020东京奥运会的主场馆，新国立竞技场在赛事结束后并未沉寂。通过引入"体育+文化+商业"的复合运营模式，这里已成为东京新的城市地标和旅游热点。

场馆周边新建了集购物、餐饮、娱乐于一体的综合商业体，同时定期举办音乐会、艺术展览等文化活动。据统计，改造后的新国立竞技场区域年接待游客超过1200万人次。

### 二、有明竞技场的科技体验

有明竞技场被改造为亚洲首个"沉浸式体育科技体验馆"，运用VR/AR技术让游客亲身体验奥运项目的魅力。这里不仅是体育迷的打卡圣地，更成为了青少年科技教育的实践基地。

### 三、文旅融合的启示

东京奥运场馆的改造案例为亚洲各国提供了宝贵的文旅融合发展经验。大型体育设施的赛后利用不应局限于单一功能，而是要结合本地文化特色、旅游资源和商业需求，打造多功能的城市公共空间。

亚洲各国在筹备大型赛事时，也应提前规划场馆的赛后利用方案，确保投资的长效回报和社会价值的最大化。`,
    a3: `## 东南亚数字支付革命：无现金社会离我们还有多远？

从新加坡到印尼，东南亚各国正加速推进数字支付基础设施建设。移动支付、电子钱包等创新支付方式正在改变数亿人的消费习惯。

### 一、东南亚数字支付现状

新加坡以超过95%的无现金支付覆盖率领先东南亚。马来西亚、泰国紧随其后，电子钱包使用率分别达到78%和72%。印尼作为东南亚最大经济体，其数字支付交易额在过去三年增长了400%，GoPay和OVO两大平台覆盖了超过2亿用户。

### 二、关键推动因素

**政策支持**：东南亚各国政府纷纷出台数字经济发展战略，推动金融科技监管沙盒机制，为数字支付创新提供了良好的政策环境。

**技术基础设施**：4G/5G网络的广泛覆盖和智能手机的高普及率为数字支付的普及奠定了技术基础。

**消费者行为变迁**：年轻消费群体对便捷、高效的支付方式有强烈需求，推动了数字支付的快速普及。

### 三、挑战与展望

尽管发展迅速，东南亚数字支付仍面临诸多挑战：各国监管标准不统一、跨境支付互通性不足、网络安全风险等。但总体来看，东南亚正在稳步迈向无现金社会，预计到2030年，该地区数字支付覆盖率将突破90%。

亚洲在线认为，东南亚数字支付的发展经验对于亚洲其他地区具有重要借鉴意义。`,
    a4: `## 韩国K-POP产业全球化：从亚洲走向世界的文化现象

韩国流行音乐产业在过去十年实现了令人瞩目的全球化扩张，不仅创造了巨大的经济效益，更成为亚洲文化输出的标志性力量。

### 一、K-POP的全球影响力

2026年，K-POP全球市场规模已突破200亿美元。BTS、BLACKPINK等顶级团体的全球巡演场场爆满，专辑在全球主要音乐市场持续霸榜。K-POP已从亚洲文化现象成长为全球主流文化力量。

### 二、成功背后的产业体系

K-POP的成功并非偶然，其背后是一套成熟的产业体系：

**系统化培训体系**：韩国娱乐公司投入大量资源培养练习生，从歌唱、舞蹈到语言、礼仪进行全方位培训。

**精良的制作水准**：高质量的音乐制作、精心编排的舞蹈、华丽的舞台效果，每一个环节都追求极致。

**数字化营销策略**：充分利用社交媒体平台进行全球化推广，与粉丝建立深度互动关系。

### 三、对亚洲文化产业的影响

K-POP的成功为亚洲各国的文化产业发展提供了重要启示。亚洲丰富的文化资源有待深度开发，通过专业的产业运作和国际化的推广策略，更多优秀的亚洲文化内容有望走向世界舞台。

亚洲在线将继续关注亚洲文化产业的发展动态，为读者带来深度分析与报道。`,
    a5: `## 亚洲美食地图：2026年必打卡的十家米其林餐厅

从东京到曼谷，从上海到新加坡，亚洲拥有全球最密集的米其林星级餐厅。我们精选了2026年最值得专程前往的十家餐厅。

### 一、东京篇

**龍吟**：连续15年获得米其林三星，以创新日式料理享誉全球。主厨山本征治将传统和食与现代分子料理技术完美融合，每一道菜品都是一件艺术品。

**Sushi Saito**：被誉为"全日本最难预定的寿司店"，由主厨斋藤孝司亲自掌勺，坚持使用当日最新鲜的食材，为食客呈现极致的握寿司体验。

### 二、上海篇

**Ultraviolet by Paul Pairet**：全球最独特的用餐体验之一，每晚仅接待10位客人，通过360度沉浸式感官体验，重新定义了高级餐饮的概念。

**福和慧**：亚洲最佳素食餐厅之一，以时令食材和禅意美学打造令人惊艳的素食料理。

### 三、曼谷篇

**Gaggan Anand**：连续多年蝉联亚洲最佳餐厅，主厨Gaggan以颠覆性的印度料理征服全球美食家。

**Sorn**：专注于泰国南部传统料理，以精致的烹饪技艺和独特的香料运用，展现了泰国南部美食的无限魅力。

### 四、新加坡篇

**Odette**：亚洲排名第一的法式餐厅，主厨Julien Royer以优雅精致的法式料理诠释亚洲食材的独特魅力。

亚洲的美食版图远不止于此。无论是街头小吃还是高级餐厅，亚洲都拥有令人惊叹的美食多样性。亚洲在线将持续为您发现更多美食宝藏。`,
    a6: `## 亚洲可再生能源发展报告：绿色转型中的机遇与挑战

亚洲各国在可再生能源领域持续加大投入，太阳能、风能等清洁能源装机容量屡创新高，绿色转型正在重塑亚洲能源格局。

### 一、亚洲可再生能源发展现状

截至2026年，亚洲可再生能源装机容量已超过全球总量的50%。中国以超过1200GW的可再生能源装机容量位居全球第一，印度、日本、韩国紧随其后。东南亚国家如越南、泰国在太阳能领域的发展也令人瞩目。

### 二、重点领域分析

**太阳能**：亚洲太阳能装机容量占全球的60%以上。中国、印度、越南是最大的太阳能市场。技术进步使得太阳能发电成本持续下降，光伏发电已成为亚洲许多地区最经济的电力来源。

**风能**：海上风电成为新的增长热点。中国、日本、韩国、台湾地区都在积极推进海上风电项目，亚洲海上风电装机容量预计到2030年将增长五倍。

**氢能**：日本、韩国在氢能领域处于全球领先地位，两国均制定了雄心勃勃的氢能发展战略，推动氢能在交通、工业、发电等领域的广泛应用。

### 三、挑战与政策建议

亚洲可再生能源发展面临电网消纳能力不足、储能技术有待突破、投资成本偏高等挑战。各国需要加强政策协调，推动技术创新，完善市场机制，共同推进亚洲能源绿色转型。

亚洲在线的持续关注将为您带来最新的绿色能源资讯和深度分析。`,
  };

  const content = articleFullContent[article.id as keyof typeof articleFullContent] || article.excerpt;

  const articleSchema = {
    headline: article.title,
    description: article.excerpt,
    author: { '@type': 'Person', name: article.author },
    datePublished: article.date,
    image: article.image,
    articleBody: content,
  };

  const breadcrumbSchema = {
    itemListElement: [
      { '@type': 'ListItem', position: 1, name: '首页', item: 'https://hjmiyhg.cn' },
      { '@type': 'ListItem', position: 2, name: article.categoryName, item: `https://hjmiyhg.cn/category/${article.category}` },
      { '@type': 'ListItem', position: 3, name: article.title },
    ],
  };

  return (
    <>
      <SchemaOrg type="Article" data={articleSchema} />
      <SchemaOrg type="BreadcrumbList" data={breadcrumbSchema} />

      <div className="min-h-screen bg-background-50">
        <Navbar />

        <main className="pt-16">
          <article>
            <header className="bg-background-100 py-14 md:py-18 px-4 md:px-6">
              <div className="max-w-4xl mx-auto">
                <nav className="flex items-center gap-2 text-sm text-foreground-500 mb-6 flex-wrap">
                  <Link to="/" className="hover:text-primary-600 transition-colors duration-200 cursor-pointer">首页</Link>
                  <i className="ri-arrow-right-s-line text-xs"></i>
                  <Link to={`/category/${article.category}`} className="hover:text-primary-600 transition-colors duration-200 cursor-pointer">
                    {article.categoryName}
                  </Link>
                  <i className="ri-arrow-right-s-line text-xs"></i>
                  <span className="text-foreground-800 line-clamp-1">{article.title}</span>
                </nav>
                <span className="inline-block px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-medium mb-4">
                  {article.categoryName}
                </span>
                <h1 className="font-heading text-2xl md:text-3xl lg:text-4xl text-foreground-950 mb-4 leading-tight">
                  {article.title}
                </h1>
                <div className="flex flex-wrap items-center gap-4 text-sm text-foreground-500">
                  <div className="flex items-center gap-2">
                    <div className="w-7 h-7 rounded-full bg-secondary-200 flex items-center justify-center">
                      <span className="text-[11px] font-medium text-secondary-700">
                        {article.author.charAt(0)}
                      </span>
                    </div>
                    <span>{article.author}</span>
                  </div>
                  <span>发布于 {article.date}</span>
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line"></i>
                    {article.views.toLocaleString()} 次阅读
                  </span>
                </div>
              </div>
            </header>

            <div className="relative h-64 md:h-96 overflow-hidden">
              <img
                src={article.image}
                alt={article.title}
                className="w-full h-full object-cover"
              />
            </div>

            <div className="max-w-4xl mx-auto px-4 md:px-6 py-10 md:py-14">
              <div className="prose prose-base md:prose-lg max-w-none text-foreground-800 leading-relaxed">
                {content.split('\n\n').map((paragraph, idx) => {
                  if (paragraph.startsWith('## ')) {
                    return (
                      <h2 key={idx} className="font-heading text-xl md:text-2xl text-foreground-950 mt-10 mb-4">
                        {paragraph.replace('## ', '')}
                      </h2>
                    );
                  }
                  if (paragraph.startsWith('### ')) {
                    return (
                      <h3 key={idx} className="font-heading text-lg md:text-xl text-foreground-900 mt-8 mb-3">
                        {paragraph.replace('### ', '')}
                      </h3>
                    );
                  }
                  if (paragraph.startsWith('**') && paragraph.endsWith('**')) {
                    return (
                      <p key={idx} className="font-semibold text-foreground-900 mt-6 mb-2">
                        {paragraph.replace(/\*\*/g, '')}
                      </p>
                    );
                  }
                  return (
                    <p key={idx} className="mb-4 text-foreground-700 leading-relaxed">
                      {paragraph}
                    </p>
                  );
                })}
              </div>

              <div className="mt-12 pt-8 border-t border-background-200/70 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
                <Link
                  to={`/category/${article.category}`}
                  className="inline-flex items-center gap-2 text-primary-600 text-sm font-medium hover:text-primary-700 transition-colors duration-200 cursor-pointer"
                >
                  <i className="ri-arrow-left-line"></i>
                  返回{article.categoryName}列表
                </Link>
                <div className="flex items-center gap-4">
                  <span className="text-xs text-foreground-500">分享到：</span>
                  <a href="#" className="w-8 h-8 rounded-full bg-background-100 flex items-center justify-center text-foreground-600 hover:bg-primary-100 hover:text-primary-600 transition-colors duration-200 cursor-pointer">
                    <i className="ri-wechat-line text-sm"></i>
                  </a>
                  <a href="#" className="w-8 h-8 rounded-full bg-background-100 flex items-center justify-center text-foreground-600 hover:bg-primary-100 hover:text-primary-600 transition-colors duration-200 cursor-pointer">
                    <i className="ri-weibo-line text-sm"></i>
                  </a>
                  <a href="#" className="w-8 h-8 rounded-full bg-background-100 flex items-center justify-center text-foreground-600 hover:bg-primary-100 hover:text-primary-600 transition-colors duration-200 cursor-pointer">
                    <i className="ri-twitter-x-line text-sm"></i>
                  </a>
                </div>
              </div>
            </div>
          </article>
        </main>

        <Footer />
      </div>
    </>
  );
}